"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialDataValueConfigurationMapSchema = exports.IncomeStatementSectionTypeSchema = exports.IncomeStatementSectionTypeIterable = exports.BalanceSheetSectionTypeSchema = exports.BalanceSheetSectionTypeIterable = exports.FinancialStatementTypeSchema = exports.FinancialStatementTypeIterable = exports.ReportFrequencySchema = exports.ReportFrequencyIterable = void 0;
const Bank = __importStar(require("./Bank"));
const v4_1 = require("zod/v4");
// *********************************************
//                BASE ATTRIBUTES
// *********************************************
exports.ReportFrequencyIterable = ['month', 'quarter', 'year'];
exports.ReportFrequencySchema = v4_1.z.enum(exports.ReportFrequencyIterable);
// *** Financial Statement Type ***
exports.FinancialStatementTypeIterable = [
    'balanceSheet',
    'incomeStatement',
];
exports.FinancialStatementTypeSchema = v4_1.z.enum(exports.FinancialStatementTypeIterable);
// *** Section Types ***
exports.BalanceSheetSectionTypeIterable = [
    'assets',
    'liabilities',
    'equity',
];
exports.BalanceSheetSectionTypeSchema = v4_1.z.enum(exports.BalanceSheetSectionTypeIterable);
exports.IncomeStatementSectionTypeIterable = [
    'income',
    'expenses',
];
exports.IncomeStatementSectionTypeSchema = v4_1.z.enum(exports.IncomeStatementSectionTypeIterable);
// *********************************************
//              BBPL CONFIGURATION
// *********************************************
exports.FinancialDataValueConfigurationMapSchema = v4_1.z.object({
    financialStatementType: exports.FinancialStatementTypeSchema.describe('Financial statement type'),
    reportFrequency: exports.ReportFrequencySchema.describe('Report frequency'),
    sectionFieldMap: v4_1.z
        .object({
        sanitizedColumnName: v4_1.z.string().describe('Sanitized column name'),
        fields: v4_1.z
            .array(v4_1.z.object({
            externalValue: v4_1.z.string().describe('External value'),
            finleyValue: v4_1.z
                .union([
                exports.BalanceSheetSectionTypeSchema,
                exports.IncomeStatementSectionTypeSchema,
            ])
                .describe('Finley value (BalanceSheetSectionTypes | IncomeStatementSectionTypes)'),
        }))
            .describe('Fields mapping externalValue to finleyValue'),
    })
        .describe('Section field map'),
    externalSubSectionSanitizedColumnNames: v4_1.z
        .array(v4_1.z.string())
        .optional()
        .describe('External sub-section sanitized column names'),
    externalKeySanitizedColumnName: v4_1.z
        .string()
        .describe('External key sanitized column name'),
    externalValueSanitizedColumnName: v4_1.z
        .string()
        .describe('External value sanitized column name'),
    currency: Bank.CurrencyCodeSchema.describe('Currency'),
    multiplier: v4_1.z.number().optional().describe('Multiplier for normalization'),
});
//# sourceMappingURL=FinancialData.js.map